import angular from 'angular';
import MODULE_NAME from '../../app'
import dataRequestService from './dataRequestService'
import overlappingService from './overlappingService'
import printerService from './printerService'

angular.module(MODULE_NAME)
.service('dataRequestService', dataRequestService)
.service('overlappingService', overlappingService)
.service('printerService', printerService)


// WEBPACK FOOTER //
// ./src/app/scripts/services/index.js